import React, { Fragment } from 'react';
import { IconButton, Menu } from '@material-ui/core';
import { MoreHoriz, MoreVert } from '@material-ui/icons';
import PropTypes from 'prop-types';

const LongMenu = ({ children, classes, horizontal, dark }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <IconButton
        classes={{ root: !dark && classes.white }}
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {horizontal ? <MoreHoriz /> : <MoreVert />}
      </IconButton>
      <Menu
        classes={{ paper: classes.paper, list: classes.list }}
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        onClick={handleClose}
      >
        {children}
      </Menu>
    </Fragment>
  );
};

LongMenu.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string),
  horizontal: PropTypes.bool,
  dark: PropTypes.bool,
};

LongMenu.defaultProps = {
  children: '',
  classes: {},
  horizontal: null,
  dark: null,
};

export default LongMenu;
